import { Component, inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SHARED_IMPORTS } from 'projects/minotaure-lib/src/shared-imports';
import { MyStelliumService } from '@lib/services/mystellium.service';
import { Clipboard } from '@angular/cdk/clipboard';
import { TOOLTIP_COPIED, TOOLTIP_DEFAULT } from '@lib/utils/app-utils';
import { OuiTooltip } from 'omnium-ui/tooltip';

@Component({
  selector: 'magic-link-dialog',
  imports: [SHARED_IMPORTS],
  templateUrl: './magic-link-dialog.component.html',
  styleUrl: './magic-link-dialog.component.scss',
})
export class MagicLinkDialogComponent {
  readonly myStelliumService = inject(MyStelliumService);
  readonly clipboard = inject(Clipboard);
  readonly dialogRef = inject(MatDialogRef<MagicLinkDialogComponent>);
  readonly data = inject<{
    magicLinkPath: string;
  }>(MAT_DIALOG_DATA);

  readonly copyTooltip = signal<string>(TOOLTIP_DEFAULT);

  copyToClipboard(value: string | undefined | null, tooltip?: OuiTooltip): void {
    if (!value) {
      return;
    }
    this.clipboard.copy(value);
    this.copyTooltip.set(TOOLTIP_COPIED);

    if (tooltip) {
      setTimeout(() => tooltip.show(), 50);
    }
  }

  resetTooltip(): void {
    this.copyTooltip.set(TOOLTIP_DEFAULT);
  }
}
